import { render } from "./MentionsLegalesView.vue?vue&type=template&id=bde33150"
import script from "./MentionsLegalesView.vue?vue&type=script&lang=js"
export * from "./MentionsLegalesView.vue?vue&type=script&lang=js"

import "./MentionsLegalesView.vue?vue&type=style&index=0&id=bde33150&lang=css"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__